export const SET_VALUES = 'SET_VALUES';

export const setDimValues = (indentifier ,values) => ({
    type: SET_VALUES,
    payload: {
        values ,indentifier
    }
})
